/**
 * Service API pour la gestion des rôles et permissions
 * Utilise le apiClient partagé (@shared)
 */

import { apiClient } from '@shared/infrastructure/http';
import type {
  ApiResponse,
  RoleDTO,
  PermissionDTO,
  CreerRoleData,
  ModifierRoleData,
  AssignerPermissionsData,
} from '../../application/dto/dtos';

const ROLES_URL = '/api/admin/roles';
const PERMISSIONS_URL = '/api/admin/permissions';

export const rolesApi = {
  /**
   * Lister tous les rôles
   */
  async listerRoles(): Promise<ApiResponse<{ roles: RoleDTO[] }>> {
    return apiClient.get<{ roles: RoleDTO[] }>(ROLES_URL);
  },

  /**
   * Obtenir un rôle par ID
   */
  async obtenirRole(idRole: string): Promise<ApiResponse<{ role: RoleDTO }>> {
    return apiClient.get<{ role: RoleDTO }>(`${ROLES_URL}/${idRole}`);
  },

  /**
   * Créer un nouveau rôle
   */
  async creerRole(data: CreerRoleData): Promise<ApiResponse<{ role: RoleDTO }>> {
    return apiClient.post<{ role: RoleDTO }>(ROLES_URL, data);
  },

  /**
   * Modifier un rôle existant
   */
  async modifierRole(
    idRole: string,
    data: ModifierRoleData,
  ): Promise<ApiResponse<{ role: RoleDTO }>> {
    return apiClient.put<{ role: RoleDTO }>(`${ROLES_URL}/${idRole}`, data);
  },

  /**
   * Supprimer un rôle
   */
  async supprimerRole(idRole: string): Promise<ApiResponse<void>> {
    return apiClient.delete<void>(`${ROLES_URL}/${idRole}`);
  },

  /**
   * Assigner des permissions à un rôle
   */
  async assignerPermissions(
    idRole: string,
    data: AssignerPermissionsData,
  ): Promise<ApiResponse<{ role: RoleDTO }>> {
    return apiClient.put<{ role: RoleDTO }>(`${ROLES_URL}/${idRole}/permissions`, data);
  },

  /**
   * Lister toutes les permissions disponibles
   */
  async listerPermissions(): Promise<ApiResponse<{ permissions: PermissionDTO[] }>> {
    return apiClient.get<{ permissions: PermissionDTO[] }>(PERMISSIONS_URL);
  },
};
